// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"FeedbackSentModal_modalContainer__39llJ","headerText":"FeedbackSentModal_headerText__2wBX_","blueButton":"FeedbackSentModal_blueButton__1zOVL"};